const rankingItems = [
  { rank: 1, title: '某顶流男星深夜密会神秘女子，酒店同框照曝光', tag: '明星爆料', hot: '🔥 128.6万', change: 'up' },
  { rank: 2, title: '某知名导演被曝潜规则女演员，多条聊天记录流出', tag: '圈内丑闻', hot: '🔥 98.3万', change: 'up' },
  { rank: 3, title: '某科技公司创始人卷款跑路，数百员工工资被拖欠', tag: '社会热点', hot: '🔥 87.2万', change: 'up' },
  { rank: 4, title: '某餐饮连锁品牌被曝使用过期食材，后厨画面曝光', tag: '食品安全', hot: '🔥 76.5万', change: 'new' },
  { rank: 5, title: '某上市公司被曝财务造假，审计机构或遭连带追责', tag: '商业内幕', hot: '🔥 65.9万', change: 'down' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-8">
          黑料热度榜
        </h2>

        <div className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-4 p-4 cursor-pointer hover:bg-background-100 transition-colors ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-full font-bold text-sm flex-shrink-0 ${
                item.rank === 1
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-primary-400 text-background-50'
                  : item.rank === 3
                  ? 'bg-accent-500 text-background-50'
                  : 'bg-secondary-200 text-foreground-700'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <span className="text-xs text-primary-500 font-medium bg-primary-50 px-2 py-0.5 rounded">{item.tag}</span>
                <h3 className="mt-1 text-sm md:text-base font-medium text-foreground-900 line-clamp-1">
                  {item.title}
                </h3>
              </div>

              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-xs text-foreground-600 whitespace-nowrap">{item.hot}</span>
                <span className={`text-xs ${
                  item.change === 'up' ? 'text-primary-500' : item.change === 'new' ? 'text-accent-500' : 'text-secondary-500'
                }`}>
                  {item.change === 'up' ? '↑' : item.change === 'new' ? 'NEW' : '↓'}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}